module.exports = __webpack_public_path__ + "static/media/logout.d3307b2e.svg";